import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { animated, useSpring } from 'react-spring';

const useStyles = makeStyles({
  toTopButton: {
    backgroundColor: '#fff',
    cursor: 'pointer',
    height: 45,
    width: 45,
    borderRadius: 50,
    border: '1px solid #b1b1b1',
    position: 'fixed',
    left: 15,
    bottom: 75,
    zIndex: 999999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:focus': {
      outline: 'none',
    },
  },
});

export function BackToTop(props: {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}) {
  // Hooks
  const classes = useStyles();
  const values = useSpring({
    opacity: 1,
    transform: 'translate3d(0, 0, 0)',
    from: { opacity: 0, transform: 'translate3d(0, 10px, 0)' },
  });

  return (
    <animated.button
      aria-label="back to top"
      className={classes.toTopButton}
      style={values}
      onClick={props.onClick}
    >
      <ArrowCircleUpIcon color="secondary" fontSize="large" />
    </animated.button>
  );
}
